module.exports = __webpack_public_path__ + "static/img/product_info.541617b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_info.png
// module id = KxPc
// module chunks = 34